module.exports = __webpack_public_path__ + "images/6-i0ea9c4892627cb820958d286e551a102.svg";